import { SET_USER } from "../actions/index";

const defaultUser = {
  name: null,
  family_name: null,
  given_name: null,
  role: null,
  language: null,
  theme: null,
  isLoaded: false,
};

const user = (state = defaultUser, action) => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        ...action.payload,
        isLoaded: true,
      };
    default:
      return state;
  }
};

export default user;
